(() => {
  const script = document.querySelector('script[data-rdr-guenstiger-bundle-fallback]');
  const bundleIcon = script?.dataset.bundleIcon || '';
  const bundleCopy = {
    label: script?.dataset.bundleLabel || '',
    title: script?.dataset.bundleTitle || '',
    intro: script?.dataset.bundleIntro || '',
    type: script?.dataset.bundleType || '',
    cta: script?.dataset.bundleCta || '',
  };
  const bundles = {
    '/products/microsoft-office-2024-professional-plus-guenstiger-de': [
      ['microsoft-windows-11-home-office-2024-professional-plus', 'Windows 11 Home + Office 2024 Professional Plus'],
      ['microsoft-windows-11-pro-office-2024-professional-plus', 'Windows 11 Pro + Office 2024 Professional Plus'],
    ],
    '/products/microsoft-office-2021-professional-plus-guenstiger-de': [
      ['microsoft-windows-11-home-office-2021-professional-plus', 'Windows 11 Home + Office 2021 Professional Plus'],
      ['microsoft-windows-11-pro-office-2021-professional-plus', 'Windows 11 Pro + Office 2021 Professional Plus'],
    ],
    '/products/microsoft-office-2019-professional-plus-guenstiger-de': [
      ['microsoft-windows-11-home-office-2019-professional-plus', 'Windows 11 Home + Office 2019 Professional Plus'],
      ['microsoft-windows-11-pro-office-2019-professional-plus', 'Windows 11 Pro + Office 2019 Professional Plus'],
    ],
    '/products/microsoft-365-family-guenstiger-de': [
      ['microsoft-windows-11-home-microsoft-365-family', 'Windows 11 Home + Microsoft 365 Family'],
      ['microsoft-365-family-adobe-acrobat-pro-2025', 'Microsoft 365 Family + Adobe Acrobat Pro 2025'],
    ],
    '/products/microsoft-365-personal-guenstiger-de': [
      ['microsoft-windows-11-home-microsoft-365-personal', 'Windows 11 Home + Microsoft 365 Personal'],
      ['microsoft-365-personal-adobe-acrobat-pro-2025', 'Microsoft 365 Personal + Adobe Acrobat Pro 2025'],
    ],
    '/products/microsoft-365-family-billiger-de': [
      ['microsoft-windows-11-home-microsoft-365-family', 'Windows 11 Home + Microsoft 365 Family'],
      ['microsoft-365-family-adobe-acrobat-pro-2025', 'Microsoft 365 Family + Adobe Acrobat Pro 2025'],
    ],
    '/products/microsoft-365-personal-billiger-de': [
      ['microsoft-windows-11-home-microsoft-365-personal', 'Windows 11 Home + Microsoft 365 Personal'],
      ['microsoft-365-personal-adobe-acrobat-pro-2025', 'Microsoft 365 Personal + Adobe Acrobat Pro 2025'],
    ],
    '/products/microsoft-windows-11-home-guenstiger-de': [
      ['microsoft-windows-11-home-microsoft-365-family', 'Windows 11 Home + Microsoft 365 Family'],
      ['microsoft-windows-11-home-microsoft-365-personal', 'Windows 11 Home + Microsoft 365 Personal'],
    ],
  };

  const path = window.location.pathname.replace(/\/$/, '');
  const fallback = null;
  if (!fallback) return;

  const mount = () => {
    const confidence = document.querySelector('.rdr-product-confidence');
    const inner = confidence?.querySelector('.rdr-product-confidence__inner');
    if (!inner || confidence.querySelector('.rdr-bundle-offers')) return;

    const section = document.createElement('div');
    section.className = 'rdr-bundle-offers';
    section.innerHTML = `
      <div class="rdr-bundle-offers__header">
        <p>${bundleCopy.label}</p>
        <h2>${bundleCopy.title}</h2>
        <span>${bundleCopy.intro}</span>
      </div>
      <div class="rdr-bundle-offers__grid">
        ${fallback.map(([handle, title]) => `
          <a href="/products/${handle}" class="rdr-bundle-offer-card">
            <div class="rdr-bundle-offer-card__media">
              ${bundleIcon ? `<img src="${bundleIcon}" alt="" width="160" height="160" loading="lazy">` : ''}
            </div>
            <div class="rdr-bundle-offer-card__body">
              <small>${bundleCopy.type}</small>
              <strong>${title}</strong>
              <em>${bundleCopy.cta}</em>
            </div>
          </a>
        `).join('')}
      </div>
    `;
    inner.appendChild(section);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
})();
